// Returns a lightweight thumbnail URL for images served by our /api/media endpoint.
// External URLs (Unsplash, etc.) and legacy paths are returned unchanged.
export const thumbUrl = (url) => {
  if (!url || !url.includes("/api/media/")) return url;
  return url.includes("?") ? `${url}&variant=thumb` : `${url}?variant=thumb`;
};
